var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<uib-accordion close-others=\"true\" ng-show=\"vm.show\"><uib-accordion-group heading=\"{{nav.name}}\" ng-repeat=\"nav in vm.nav |orderBy: 'sortOrder'\"><div ng-repeat=\"link in nav.links | orderBy: 'sortOrder'\"><a ui-sref=\"{{link.sref}}\">{{link.name}}</a><hr ng-if=\"link.endSection\" style=\"margin-top: 5px; margin-bottom: 5px;\"/></div></uib-accordion-group></uib-accordion>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./navNinja/navNinja.jade
// module id = 103
// module chunks = 0